export default __webpack_public_path__ + "static/media/sticker-or.38d960a7.png";